import React from 'react';
import { RelativeDatePeriod, RelativeDateType, RelativeUnit } from '@fabric-ui/components';
import { Automations, History } from '@fabric-ui/icons';

export enum TimeframeOptionValue {
  Current = 'Current',
  Historical = 'Historical',
}

export const TimeframeOptions = {
  current: { value: TimeframeOptionValue.Current, icon: <Automations /> },
  historic: { value: TimeframeOptionValue.Historical, icon: <History /> },
};

export const dateFormat = 'MMM dd, yy';
export const shortDateFormat = 'MM/dd/yy';

export const newDefaultTimeRange = {
  value: {
    relative: {
      unit: RelativeUnit.DAYS,
      value: 30,
      periodBehaviour: RelativeDateType.last,
    },
  },
  preset: {
    count: 30,
    period: RelativeDatePeriod.days,
    type: RelativeDateType.last,
  },
};
